import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import BgImg from "../../../images/case-studies/amj/banner_amj.webp";

function Banner() {
  return (
    <section
      className="banner_amj"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banner_logo">
              <StaticImage
                src="../../../images/case-studies/amj/logo.webp"
                alt="TekRevol"
                className="logo_amj"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={152}
                height={153}
              />
            </div>
            <h1>Fitness-Focused Mobile App Development</h1>
            <p>
              Employee wellbeing and company’s performance have a direct
              relation.
            </p>
            <div className="banner_btn">
              <Link to="https://apps.apple.com/us/app/ww-workplace-wellness/id1568732986">
                <StaticImage
                  src="../../../images/case-studies/amj/app_store.webp"
                  alt="TekRevol"
                  className=""
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={164}
                  height={60}
                />
              </Link>
              <Link to="https://play.google.com/store/apps/details?id=com.app.workplacewellness">
                <StaticImage
                  src="../../../images/case-studies/amj/google_play.webp"
                  alt="TekRevol"
                  className="btn_amj "
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={164}
                  height={60}
                />
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
